export enum PaymentProvider {
  STRIPE = 'stripe',
  TILLED = 'tilled',
}
